(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.VueGoogleAdsense = factory());
}(this, (function () { 'use strict';

  var constant = {
    ADS_SCRIPT: '//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'
  };

  var mixin = {
    props: {
      rootClass: {
        type: String,
        default: 'adswrapper'
      },
      dataAdClient: {
        type: String,
        default: ''
      },
      dataAdSlot: {
        type: String,
        default: ''
      },
      dataAdTest: {
        type: String,
        default: ''
      }
    },
    data: function data() {
      return {
        ADS_SCRIPT: constant.ADS_SCRIPT
      };
    }
  };

  //
  var script = {
    name: 'Adsense',
    mixins: [mixin]
  };

  /* script */
              const __vue_script__ = script;
              
  /* template */
  var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.rootClass},[_c('script2',{attrs:{"type":"text/javascript","async":"","src":_vm.ADS_SCRIPT}}),_c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block"},attrs:{"data-ad-client":_vm.dataAdClient,"data-ad-slot":_vm.dataAdSlot,"data-ad-test":_vm.dataAdTest,"data-ad-format":"auto"}}),_c('script2',[_vm._v("\n    (adsbygoogle = window.adsbygoogle || []).push({});\n  ")])],1)};
  var __vue_staticRenderFns__ = [];

    /* style */
    const __vue_inject_styles__ = undefined;
    /* scoped */
    const __vue_scope_id__ = undefined;
    /* module identifier */
    const __vue_module_identifier__ = undefined;
    /* functional template */
    const __vue_is_functional_template__ = false;
    /* component normalizer */
    function __vue_normalize__(
      template, style, script$$1,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "Adsense.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var Adsense = __vue_normalize__(
      { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
      __vue_inject_styles__,
      __vue_script__,
      __vue_scope_id__,
      __vue_is_functional_template__,
      __vue_module_identifier__,
      undefined,
      undefined
    );

  //
  var script$1 = {
    name: 'InArticleAdsense',
    mixins: [mixin]
  };

  /* script */
              const __vue_script__$1 = script$1;
              
  /* template */
  var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.rootClass},[_c('script2',{attrs:{"type":"text/javascript","async":"","src":_vm.ADS_SCRIPT}}),_c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block","text-align":"center"},attrs:{"data-ad-layout":"in-article","data-ad-format":"fluid","data-ad-client":_vm.dataAdClient,"data-ad-slot":_vm.dataAdSlot,"data-ad-test":_vm.dataAdTest}}),_c('script2',[_vm._v("\n    (adsbygoogle = window.adsbygoogle || []).push({});\n  ")])],1)};
  var __vue_staticRenderFns__$1 = [];

    /* style */
    const __vue_inject_styles__$1 = undefined;
    /* scoped */
    const __vue_scope_id__$1 = undefined;
    /* module identifier */
    const __vue_module_identifier__$1 = undefined;
    /* functional template */
    const __vue_is_functional_template__$1 = false;
    /* component normalizer */
    function __vue_normalize__$1(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "InArticleAdsense.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var InArticleAdsense = __vue_normalize__$1(
      { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
      __vue_inject_styles__$1,
      __vue_script__$1,
      __vue_scope_id__$1,
      __vue_is_functional_template__$1,
      __vue_module_identifier__$1,
      undefined,
      undefined
    );

  //
  var script$2 = {
    name: 'InFeedAdsense',
    mixins: [mixin],
    props: {
      dataAdLayoutKey: {
        type: String,
        default: '-fg+5n+6t-e7+r'
      }
    }
  };

  /* script */
              const __vue_script__$2 = script$2;
              
  /* template */
  var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.rootClass},[_c('script2',{attrs:{"type":"text/javascript","async":"","src":_vm.ADS_SCRIPT}}),_c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block"},attrs:{"data-ad-format":"fluid","data-ad-layout-key":_vm.dataAdLayoutKey,"data-ad-client":_vm.dataAdClient,"data-ad-slot":_vm.dataAdSlot,"data-ad-test":_vm.dataAdTest}}),_c('script2',[_vm._v("\n    (adsbygoogle = window.adsbygoogle || []).push({});\n  ")])],1)};
  var __vue_staticRenderFns__$2 = [];

    /* style */
    const __vue_inject_styles__$2 = undefined;
    /* scoped */
    const __vue_scope_id__$2 = undefined;
    /* module identifier */
    const __vue_module_identifier__$2 = undefined;
    /* functional template */
    const __vue_is_functional_template__$2 = false;
    /* component normalizer */
    function __vue_normalize__$2(
      template, style, script,
      scope, functional, moduleIdentifier,
      createInjector, createInjectorSSR
    ) {
      const component = (typeof script === 'function' ? script.options : script) || {};

      // For security concerns, we use only base name in production mode.
      component.__file = "InFeedAdsense.vue";

      if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;

        if (functional) component.functional = true;
      }

      component._scopeId = scope;

      return component
    }
    /* style inject */
    
    /* style inject SSR */
    

    
    var InFeedAdsense = __vue_normalize__$2(
      { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
      __vue_inject_styles__$2,
      __vue_script__$2,
      __vue_scope_id__$2,
      __vue_is_functional_template__$2,
      __vue_module_identifier__$2,
      undefined,
      undefined
    );

  var pluginAdsense = {
    install: function install(Vue) {
      Vue.component(Adsense.name, Adsense);
    }
  };
  var pluginInArticleAdsense = {
    install: function install(Vue) {
      Vue.component(InArticleAdsense.name, InArticleAdsense);
    }
  };
  var pluginInFeedAdsense = {
    install: function install(Vue) {
      Vue.component(InFeedAdsense.name, InFeedAdsense);
    }
  };
  Adsense.install = pluginAdsense.install;
  InArticleAdsense.install = pluginInArticleAdsense.install;
  InFeedAdsense.install = pluginInFeedAdsense.install;
  var plugin = {
    Adsense: Adsense,
    InArticleAdsense: InArticleAdsense,
    InFeedAdsense: InFeedAdsense
  };

  return plugin;

})));
